<template>
  <div id="app">
    <div class="routerView">
      <router-view />
    </div>
    <!-- <Alert></Alert> -->
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "./assets/style/reset.css";

#app {
  height: 100%;
  font-family: "Microsoft Yahei", "Franklin Gothic Medium", "Arial Narrow",
    Arial, sans-serif;
}
.routerView {
  width: 100%;
  height: 100%;
}
@supports (bottom: env(safe-area-inset-bottom)) {
  body,
  .footer {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
